<style>
select:invalid {
  color: gray;
}

option {
  color: black;
}
.popover {
  font-family: "Sarabun", sans-serif;
  max-width: 350px;
}
.popover-header {
  padding-left: 0.9375rem;
  padding-bottom: 7px;
  padding-top: 7px;
  margin-bottom: 0;
  font-size: 15px;
  border-bottom: 1px solid #ddd;
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px);
}
.popover-header:empty {
  display: none;
}
.btn-edit-profile {
  position: absolute;
  bottom: 0px;
  right: 0px;
  background: white;
  width: 26px;
  height: 26px;
  padding: 1px;
  border-radius: 50%;
  cursor: pointer;
}
</style>

<template>
  <!-- Page length options -->
  <div>
    <div
      v-if="integrations == null"
      class="card"
    >
      <div class="content">
        <placeholder-content is-load="true" />
      </div>
    </div>
    <div
      class="card"
      v-else
    >
      <placeholder-content />
      <div class="card-title my-0">
        <div class="card-header">
          <p class="h5 font-weight-semibold">
            {{ $t("Sale Contact") }}
            <span v-if="planSubportSaleConteact">
              <span
                class="badge bg-yellow-400 height-100 mt-1 ml-2"
                v-if="hasFeature && saleContactAdvance == true"
              >
                {{ $t("Advance") }}
              </span>
              <span
                class="badge sp-enable height-100 mt-1 ml-2"
                v-else
              >
                {{ $t("Basic") }}
              </span>
            </span>
          </p>
          <div 
            v-if="planSubportSaleConteact" 
            class="text-secondary mt-n1"
          >
            {{ $t("Enable and manage your sale contact.") }}
          </div>
          <div v-else>
            {{ $t("Manage your sale contact.") }}
          </div>
        </div>
      </div>
      <div class="border-top px-3 pt-3 pb-2">
        <ul class="list-group list-group-flush py-0 pb-0">
          <li
            class="list-group-item d-flex justify-content-between align-items-center p-0 pl-2"
          >
            <div 
              v-if="planSubportSaleConteact" 
              class="d-flex row w-100"
            >
              <div class="mr-2 pt-1">
                <toggle-button
                  name="is_contact_default"
                  id="is_contact_default"
                  @change="changeContactAdvance"
                  :width="38"
                  color="#64BD63"
                  :speed="200"
                  :margin="1"
                  v-model="saleContactAdvanceToggle"
                  sync
                />
              </div>
              <div class="col-5">
                <div class="h6">
                  <span class="d-contents">{{ $t("Sale Contact Advance") }}</span>

                  <span class="text-danger">
                    <a
                      style="color: #706f72"
                      data-trigger="hover"
                      data-popup="popover-custom"
                      data-placement="right"
                      :title="$t('Suggestion')"
                      :data-content="
                        '<div ' +
                          classImg +
                          '>' +
                          $t('_hoverPopup.Sale Contact Advance') +
                          '</div><div ><img src=' +
                          img2 +
                          ' ' +
                          sizeImgSMS +
                          '><div ' +
                          classImg +
                          '>' +
                          $t('Sale Contact Basic') +
                          '</div><img src=' +
                          img1 +
                          ' ' +
                          sizeImgSMS +
                          '></div>'
                      "
                      data-html="true"
                    >
                      <i class="fas fa-info-circle" />
                    </a>
                  </span>
                </div>
                <div class="text-secondary mt-n2">
                  {{ $t("Enable sale contact advance to manage other sale contact.") }}
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="card mt-2 mb-3 mx-3 pt-0">
        <div class="card-body pt-0 px-0 py-0">
          <div class="tab-content">
            <div class="tab-pane fade show active">
              <div
                class="dataTables_wrapper no-footer"
                v-if="saleContactAdvance && !load"
              >
                <div class="datatable-header d-flex px-2">
                  <div class="dt-buttons">
                    <button
                      type="button"
                      @click="addSaleContact"
                      class="btn btn-primary mr-2"
                      data-toggle="modal"
                      data-target="#modal_add_sale_contact"
                    >
                      <i class="fas fa-plus-circle mr-2" />{{ $t("Add Sale Contact") }}
                    </button>
                  </div>
                  <filters-bar
                    @searchText="searchText"
                    ref="changeCountTab"
                  />
                  <advanceFilter
                    v-if="isadvanceFilter"
                    @close="isadvanceFilter = false"
                    :filter="filter"
                    @channel="getChannels"
                  />
                  <filters-more
                    ref="filtersMore"
                    @sendfilter="onClickChild"
                  />
                </div>
              </div>

              <placeholder-content 
                :is-load="load"
                v-if="load" 
                class="p-3"
              />

              <table
                class="table"
                v-else
              >
                <thead v-if="hasFeature && saleContactAdvance == true">
                  <tr>
                    <th width="5%">
                      <i class="fa-solid fa-bars" />
                    </th>
                    <th
                      width="42%"
                      class="pl-1"
                    >
                      {{ $t("Sale Contact") }}
                    </th>
                    <th
                      width="20%"
                      v-if="hasFeature && saleContactAdvance == true"
                    >
                      {{ $t("Status") }}
                    </th>
                    <th
                      width="20%"
                      v-if="hasFeature && saleContactAdvance == true"
                    >
                      {{ $t("Created Date") }}
                    </th>
                    <th
                      class="text-center"
                      v-if="hasFeature && saleContactAdvance == true"
                    >
                      {{ $t("Action") }}
                    </th>
                  </tr>
                </thead>
                <thead v-else>
                  <tr>
                    <th width="5%">
                      <i class="fa-solid fa-bars" />
                    </th>
                    <th
                      width="95%"
                      class="pl-1"
                    >
                      {{ $t("Sale Contact") }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <draggable
                    v-model="integrations"
                    @start="drag = true"
                    @end="drag = false"
                    @change="savelog"
                    class="d-contents"
                    chosen-class="chosen"
                    draggable=".item:not(.active-on-0)"
                  >
                    <tr
                      v-for="element in integrations"
                      :key="element.id"
                      :class="
                        'cursor-pointer item active-' + advance + '-' + element.is_active
                      "
                    >
                      <template>
                        <td>
                          <i class="fa-solid fa-bars" />
                        </td>
                        <td class="pl-1">
                          <span
                            v-if="hasFeature && saleContactAdvance == true"
                            :ref="'row' + element.id"
                            @click="onActionClicked('edit-item', element)"
                            data-toggle="modal"
                            data-target="#right_modal_lg"
                          >  
                            <img
                              class="mr-1"
                              :src="element.integration_type.logo"
                            >
                            {{ element.name }}
                            <span
                              v-if="
                                element.is_default == 1 &&
                                  hasFeature &&
                                  saleContactAdvance == true
                              "
                              class="badge sp-default ml-2"
                            >
                              <i class="fa-solid fa-star mr-1" />{{ $t("Default") }}
                            </span>
                          </span>
                          <template v-else>
                            <img
                              class="mr-1"
                              :src="element.integration_type.logo"
                            >
                            {{ element.name }}
                          </template>
                        </td>
                        <td v-if="hasFeature && saleContactAdvance == true">
                          <div v-if="element.is_active == 1">
                            <span class="badge sp-enable">
                              <i class="fa-solid fa-circle-check mr-1" />{{
                                $t("_saleContact.Enable")
                              }}
                            </span>
                          </div>
                          <div v-else>
                            <span class="badge sp-disable">
                              <i class="fa-solid fa-circle-xmark mr-1" />
                              {{ $t("_saleContact.Disable") }}
                            </span>
                          </div>
                        </td>
                        <td v-if="hasFeature && saleContactAdvance == true">
                          {{ convertTimezone(element.created_date) }}
                        </td>
                        <td
                          class="text-center"
                          v-if="hasFeature && saleContactAdvance == true"
                        >
                          <div class="list-icons">
                            <div class="dropdown">
                              <a
                                :href="'#'"
                                :class="'list-icons-item'"
                                :data-toggle="'dropdown'"
                              >
                                <i class="icon-menu9" />
                              </a>
                              <div class="dropdown-menu dropdown-menu-right">
                                <a
                                  :ref="'row' + element.id"
                                  href="javascript:void(0);"
                                  @click="onActionClicked('edit-item', element)"
                                  data-id=""
                                  data-toggle="modal"
                                  data-target="#right_modal_lg"
                                  class="dropdown-item"
                                >
                                  <i class="fa-1x fa-solid fa-square-pen mr-2" />
                                  {{ $t("Edit") }}
                                </a>
                                <a
                                  v-if="element.is_standard == 0"
                                  href="javascript:void(0);"
                                  @click="onActionClicked('delete-item', element)"
                                  class="dropdown-item"
                                >
                                  <i class="fa-1x fa-solid fa-trash-can mr-2" />
                                  {{ $t("Delete") }}
                                </a>
                              </div>
                            </div>
                          </div>
                        </td>
                      </template>
                    </tr>
                  </draggable>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <ModalAddSaleContact ref="ModalAddSaleContact" />
    </div>
  </div>
</template>
<script>
import Api from "@/services/endpoint/tenant.service";
import FieldsDef from "./assets/template/vuetable/FieldsDef.js";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import FiltersBar from "./assets/template/vuetable/FiltersBar";
import advanceFilter from "./AdvanceFilter";
import draggable from "vuedraggable";
import ModalAddSaleContact from "./ModalAddSaleContact";
import { showTextPicker } from "./assets/js/Params";
import { ToggleButton } from "vue-js-toggle-button";
import FiltersMore from "./assets/template/vuetable/FiltersMore";
import PlaceholderContent from "@/plugins/PlaceholderContent.vue";
import {
    convertTimezone
} from "@/common/tenancy/convertTimezone";
import moment from "moment";

export default {
  name: "SaleContact",
  data() {
    return {
      hasFeature: true,
      filters: {
        q: "",
        tags: [],
        publish: [],
        integrationType: [],
        dateRange: {
          startDate: null,
          endDate: null,
        },
        status: [],
        page: 1,
      },
      vuetableFields: false,
      countFilter: 0,
      queryParams: {},
      fields: FieldsDef,
      isadvanceFilter: false,
      isFiltersMore: true,
      paginationComponent: "vuetable-pagination",
      count: {
        0: 0,
        1: 0,
        2: 0,
        3: 0,
      },
      checkTab: 0,
      integrations: null,
      saleContactAdvanceToggle: null,
      saleContactAdvance: null,
      advance: "off",
      isActive: true,
      submitAction: "create-sale-contact",
      integration: {
        id: "",
        name: "",
        integration_type_id: 0,
        is_active: true,
        url: "",
      },
      validate_name: false,
      unavailable_name: false,
      validate_channel: false,
      validate_url: false,
      validate: true,
      typeList: null,
      store: {
        id: 1,
      },
      img1: require("@/assets/images/Group21706.png"),
      img2: require("@/assets/images/Group21705.png"),
      classImg: 'class="py-1"',
      sizeImgSMS: 'width="100%"',
      loading: true,
      load: true,
      isStandard:'',
    };
  },
  components: {
    FiltersBar,
    advanceFilter,
    draggable,
    ToggleButton,
    ModalAddSaleContact,
    FiltersMore,
    PlaceholderContent,
  },
  computed: {
    showTextPicker: function () {
      if (this.filters.dateRange.startDate && this.filters.dateRange.endDate) {
        return showTextPicker(this.filters.dateRange);
      } else {
        return showTextPicker(this.filters.dateRange);
      }
    },
    planSubportSaleConteact: function () {
      if (this.$store.state.user.planGroup == "goship" && this.$store.state.user.planSerie == "free") {
        return false;
      } else if (this.$store.state.user.planGroup == "gosell" && this.$store.state.user.planSerie == "free") {
        if (this.$store.state.user.planLastPurchase) {
          let dateEndPlanActive = convertTimezone.utcToLocal(this.$store.state.user.planLastPurchase.ends_at);
          return dateEndPlanActive <= moment().format('Y-m-d H:m:s') ? true : false;
        }
        return false;
      }

      return true;
    },
    planSubportSaleConteactSwitch: function () {
      let planGroup = this.$store.state.user.planGroup;
      let planSerie = this.$store.state.user.planSerie;
      if (planGroup == "goship" && planSerie == "free" || planGroup == "gosell" && planSerie == "free") {
        return false;
      } 
      return true;
    }
  },
  methods: {
    dataManager(sortOrder, pagination) {
      if (sortOrder.length > 0) {
        this.filters.sort = sortOrder
          .map((item) => `${item.sortField}|${item.direction}`)
          .join(",");
      }
      this.setParams(this.filters);
    },
    setPerPage(perPage) {
      this.filters.per_page = perPage;
      this.setParams(this.filters);
    },
    async feedData() {
      let resSaleContact = await Api.Setting.getSaleContactAdvance(this.store.id);

      if (this.hasFeature && resSaleContact.data.is_channel_advance == 1) {
        this.advance = "on";
        this.saleContactAdvance = true;
        this.saleContactAdvanceToggle = true;
      }
      if (this.hasFeature && resSaleContact.data.is_integration_advance == 1) {
        this.advance = "on";
        this.saleContactAdvance = true;
        this.saleContactAdvanceToggle = true;
      }
      this.load = false;
    },
    async setParams(filters) {
      this.showLoader();
      // this.filters.page = this.$refs.vuetable.currentPage;
      this.filters.page = 1;
      Object.keys(filters).map((key) => {
        this.queryParams[key] = filters[key];
      });

      let queryString = "?integration_group_id=1,2,5&not_name=Salepage&not_sync=yes&exclude-social-integration=true";

      if (this.saleContactAdvance == false || this.saleContactAdvance == null) {
        queryString += "&is_standard=1";
      }

      if (Object.keys(this.queryParams).length > 0) {
        queryString += "&" + $.param(this.queryParams);
      }

      let data = {};
      data = await this.$storeIndex.mutations.vueTableFormatJson(
        await Api.Setting.getIntegration(queryString)
      );
      this.integrations = data.data; 
      this.integrations = this.integrations.filter(function(item){
        if(item.integration_type.code != "CRM"){
          return item;
        }
      });
      this.hideLoader();
      // console.log(this.integrations);
      if (this.typeList == null) {
        let response = await Api.Setting.getIntegrationType(queryString);
        this.typeList = response.data.data; 
        this.typeList = this.typeList.filter(function(item){
          if(item.code != "CRM"){
            return item;
          }
        });
        console.log('this.typeList 1111 =',this.typeList);
      }
    },
    searchText(searchText) {
      this.filters.q = searchText;
      this.setParams(this.filters);
    },
    showLoader() {
      this.loading = "loading";
    },
    hideLoader() {
      this.loading = "";
    },
    onPaginationData(tablePagination) {
      this.$refs.paginationInfo.setPaginationData(tablePagination);
      this.$refs.pagination.setPaginationData(tablePagination);

      this.count[this.checkTab] = tablePagination.total;
    },
    toggleCheckboxs(event, dataItem) {
      this.selectedTo = this.$refs.vuetable.selectedTo;
    },
    toggleAllCheckboxes(event) {
      //this.isSelectAll = event
      this.selectedTo = this.$refs.vuetable.selectedTo;
    },
    onInitialized(fields) {
      this.vuetableFields = fields.filter((field) => field.togglable);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    onClickChild(value) {
      this.totalCount = value.totalCount;
      this.countFilter = value.totalCount;
      this.filters.integration_type_id = value.integration_type_id;
      this.filters.q = value.q;
      this.setParams(this.filters);
    },
    async savelog(data) {
      let integrations = [];
      $.each(this.integrations, function (key, val) {
        integrations.push({
          integration_type_id: val.integration_type_id,
          integration_id: val.id,
        });
      });

      let param = {
        integrations: integrations,
        saleContactAdvance: this.saleContactAdvance,
        filters: this.filters.integrationType,
      };
      let response = await Api.Integration.sortIntegration(param);

      this.integrations = response.data.data;
      this.integrations = this.integrations.filter(function(item){
        if(item.integration_type.code != "CRM"){
          return item;
        }
      });

      let responseUpdate = response.data.response;
      if (responseUpdate != null && this.hasFeature && this.saleContactAdvance == true) {
        this.$toastr.s(
          this.$t(responseUpdate),
          "<span class='t-icon icon-checkmark3'></span>" + this.$t("Success")
        );
      }
    },
    async changeContactAdvance(e) {
      let ref = this;
      if (ref.hasFeature && ref.planSubportSaleConteactSwitch) {
        let isIntegrationAdvance = "0";
        if (e.value) {
          isIntegrationAdvance = "1";
          ref
            .$swal({
              title: ref.$t("Open Sale Contact Advance"),
              icon: "warning",
              iconColor: "#FF7043",
              html: ref.$t("Are you sure to open Sale Contact Advance"),
              showCancelButton: true,
              confirmButtonText: ref.$t("Ok"),
              cancelButtonText: ref.$t("Cancel"),
              buttonsStyling: false,
              customClass: {
                confirmButton: "btn btn-primary mr-2",
                cancelButton: "btn btn-light",
                loader: "custom-loader",
              },
              loaderHtml: '<div class="spinner-border text-primary"></div>',
              focusConfirm: false,
              showLoaderOnConfirm: true,
            })
            .then(async (result) => {
              console.log(result, 'resultresultresultresultresult');
              ref.load = true; 
              if (result.isConfirmed) {
                

                let param = { is_integration_advance: isIntegrationAdvance };
                await Api.Setting.putSaleContactAdvance(ref.store.id, param);

                let queryString = "?integration_group_id=1,2,5&not_name=Salepage&not_sync=yes";

                let data = await ref.$storeIndex.mutations.vueTableFormatJson(
                  await Api.Integration.getIntegration(queryString)
                );

                ref.advance = e.value ? "on" : "off";
                ref.saleContactAdvance = e.value;
                ref.saleContactAdvanceToggle = e.value;

                ref.integrations = data.data; 
                ref.integrations = ref.integrations.filter(function(item){
                  if(item.integration_type.code != "CRM"){
                    return item;
                  }
                }); 
                
              } else {
                ref.advance = "off";
                ref.saleContactAdvance = false;
                ref.saleContactAdvanceToggle = false;
              }
              ref.load = false; 
            })
            .catch((error) => {
              console.log(error, "error2");
            });
        } else {
          ref
            .$swal({
              title: ref.$t("Close Sale Contact Advance"),
              icon: "warning",
              iconColor: "#FF7043",
              html: ref.$t("Are you sure to close Sale Contact Advance"),
              showCancelButton: true,
              confirmButtonText: ref.$t("Ok"),
              cancelButtonText: ref.$t("Cancel"),
              buttonsStyling: false,
              customClass: {
                confirmButton: "btn btn-primary mr-2",
                cancelButton: "btn btn-light",
                loader: "custom-loader",
              },
              loaderHtml: '<div class="spinner-border text-primary"></div>',
              focusConfirm: false,
              showLoaderOnConfirm: true,
            })
            .then(async (result) => {
              ref.load = true;
              if (result.isConfirmed) {
                let param = { is_integration_advance: isIntegrationAdvance };
                Api.Setting.putSaleContactAdvance(ref.store.id, param);
                ref.advance = e.value ? "on" : "off";
                ref.saleContactAdvance = e.value;
                ref.saleContactAdvanceToggle = e.value;

                let queryString =
                  "?integration_group_id=1,2,5&not_name=Salepage&is_standard=1&not_sync=yes";

                let data = await ref.$storeIndex.mutations.vueTableFormatJson(
                  await Api.Integration.getIntegration(queryString)
                );
                ref.integrations = data.data; 
                ref.integrations = ref.integrations.filter(function(item){
                  if(item.integration_type.code != "CRM"){
                    return item;
                  }
                });
                console.log('this.integrations 2222 =',ref.integrations);
              } else {
                ref.advance = "on";
                ref.saleContactAdvance = true;
                ref.saleContactAdvanceToggle = true;
              }
              ref.load = false;
            })
            .catch((error) => {
              console.log(error, "error2");
            });

        }
      } else {
        let urlSubscriptions = ref.$router.resolve({name: 't.a.premium.subscriptions'}).href;
        ref.$toastr.w(
          ref.$t("Please upgrade your plan.") + " <a class='text-primary' href='"+ urlSubscriptions+"'>" + ref.$t("Click here.") + "</a>",
          "<span class='icon-info22'></span>" + ref.$t("Subscription Expired!")
        );
        ref.$swal.close();
        ref.advance = "off";
        ref.saleContactAdvance = false;
        ref.saleContactAdvanceToggle = false;
      }
      this.load = false;
    },
    addSaleContact() {
      (this.submitAction = "create-sale-contact"),
        (this.integration.integration_type_id = 1);
      this.integration.name = "";
      this.integration.url = "";
      this.integration.is_active = true;
      this.isStandard = "";

      this.validate_name = false;
      this.unavailable_name = false;
      this.validate_url = false;
      this.validate_channel = false;
      this.validate = true;
      this.$refs.ModalAddSaleContact.feedData("Facebook");
    },
    onActionClicked(key, data) {
      const ref = this;
      if (ref.hasFeature) {
        switch (key) {
          case "edit-item":
            this.submitAction = "update-sale-contact";
            let isActive = false;
            if (data.is_active == 1) {
              isActive = true;
            }
            this.integration.id = data.id;
            this.integration.name = data.name;
            this.integration.is_active = isActive;
            this.integration.integration_type_id = data.integration_type_id;
            this.integration.url = data.url;
            this.isStandard = data.is_standard;

            this.$refs.ModalAddSaleContact.feedData(data.integration_type.name);
            $("#modal_add_sale_contact").modal("show");
            break;

          case "delete-item":
            var titleMessage = this.$t("Delete Sale Contact ?");
            var htmlMessage = this.$t("You will not be able to undo this action.");
            let confirmButtonText =
              '<i class="fas fa-check-circle mr-1"></i>' + this.$t("Confirm");
            this.$swal({
              title: titleMessage,
              icon: "warning",
              iconColor: "#FF7043",
              html: htmlMessage,
              showCancelButton: true,
              confirmButtonText: confirmButtonText,
              cancelButtonText: this.$t("Cancel"),
              buttonsStyling: false,
              customClass: {
                confirmButton: "btn btn-primary mr-2",
                cancelButton: "btn btn-light",
                loader: "custom-loader",
              },
              loaderHtml: '<div class="spinner-border text-primary"></div>',
              focusConfirm: false,
              showLoaderOnConfirm: true,
              preConfirm: async function () {
                try {
                  let response = await Api.Setting.deleteSaleContact(data.id);
                  if (response.data.response == 1) {
                    ref.$toastr.s(
                      ref.$t("Delete Sale Contact Success"),
                      "<span class='t-icon icon-checkmark3'></span>" + ref.$t("Success")
                    );
                  } else {
                    ref.$toastr.w(
                      ref.$t("Delete Sale Contact Failed"),
                      "<span class='icon-warning22'></span>" + ref.$t("Warning")
                    );
                  }
                  ref.$swal.close();
                  ref.integrations = response.data.data;
                } catch (error) {
                  if (
                    error.response.data.message.indexOf(
                      "You can not active plan feature"
                    ) != -1
                  ) {
                    ref.$toastr.Add({
                      type: "warning",
                      title:
                        "<span class='icon-warning22 mr-2'></span>" +
                        ref.$t("Something went wrong."),
                      msg: ref.$t(
                        "Save information failed. This feature is not included in your store's package."
                      ),
                      clickClose: true,
                      timeout: 5000,
                      position: "toast-top-right",
                    });
                  } else {
                    console.log(error.response, "error");
                  }
                }
              },
            });
            break;

          default:
        }
      } else {
        ref.$toastr.w(
          ref.$t("Please Subscription Plan GoSell") + " (Basic)",
          "<span class='icon-warning22'></span>" + ref.$t("Warning")
        );
      }
    },
    convertTimezone(date){
        return convertTimezone.utcToLocal(date);
    },
  },
  watch: {
    paginationComponent(newVal, oldVal) {
      this.$nextTick(() => {
        this.$refs.pagination.setPaginationData(this.$refs.vuetable.tablePagination);
      });
    },
  },

  async mounted() {
    var featureName = "feature-sale-contact";
    let hasFeature = await Api.Feature.postHasFeature(featureName);
    if (!hasFeature.data.status) {
      this.hasFeature = false;
    }
    await this.feedData();
    await this.setParams([]);
    _componentPopoverCustomHeaderColor();
  },
};
var _componentPopoverCustomHeaderColor = function () {
  $("[data-popup=popover-custom]").popover({
    template:
      '<div class="popover border-light"><div class="arrow"></div><p class="popover-header bg-light font-weight-bold"></p><div class="popover-body"></div></div>',
  });
};
</script>
<style scoped>
.d-contents {
  display: contents !important;
}
.pull-right {
  float: right;
}
.pull-left {
  float: left;
}
thead {
  background-color: #fafafa;
}
.sp-enable {
  background-color: #66bb6a;
  color: #fafafa;
}
.sp-disable {
  background-color: #888888;
  color: #fafafa;
}
.sp-default {
  background-color: #29b6f6;
  color: #fafafa;
}
.height-100 {
  height: 100%;
}
.bg-yellow-400 {
  background-color: #ffa726;
}
.chosen {
  transform: translateZ(0px) !important;
  background-color: #ffffff !important;
}
.list-icons-item-disabled {
  color: #bfbfbf !important;
}
</style>



// WEBPACK FOOTER //
// src/components/tenancy/admin/settings/sale/sale-contact/Index.vue